<template>
    <div>
        <modal :name="modal_name" class="final-modal activity-popup" transition="nice-modal-fade" >
            <div class="v-modal-content" style="border-radius: 5px !important;">
                <div class="v-modal-header d-flex align-items-center justify-content-end">
                    <span @click="hideType()" class="closePopup">
                        <i class="icon-close text-secondary fw-600"></i>
                    </span>
                </div>
                <div class="v-modal-body pt-0 pb-0">
                    <div class="v-modal-layout d-form pb-5" style="overflow: initial !important;">
                        <div class="activty-content">
                            <div class="activty-bg">
                                {{caption}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>
<script>
export default {
    props:['modal_name','caption'],
    methods:{
        hideType(){
            this.$modal.hide(this.modal_name);
        },
    }
}
</script>
<style scoped>
.closePopup{
    background-color: transparent !important;
    font-weight: 600;
    font-size: 20px;
    margin-right: 7px;
    color: #005dae;
    cursor: pointer;
}
.activty-content{
    display: flex;
    background-color: transparent;
    margin: 0px 10px;
}
.activty-bg{
    margin: 0 0 0 20px;
    padding:10px;
    border-radius: 1.5px;
    background-color: #a1cbfb;
    width: 100%;
    word-break: break-all;
}
</style>